import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
const imgPath = '/i3/saas_templates/shopiko/';

const BG = [
	{
		name: 'Spark',
		img: imgPath + 'Spark.jpg',
		href: 'https://spark.shopiko.bg'
	},
	{
		name: 'Gimp',
		img: imgPath + 'Gimp.jpg',
		href: 'https://gimp.shopiko.bg'
	},
	{
		name: 'Fashion Weeks',
		img: imgPath + 'FashionWeeks.jpg',
		href: 'https://fashionweeks.shopiko.bg'
	},
	{
		name: 'Luxury',
		img: imgPath + 'Luxury.jpg',
		href: 'https://luxury.shopiko.bg'
	},
	{
		name: 'Boutique',
		img: imgPath + 'Boutique.jpg',
		href: 'https://boutique.shopiko.bg'
	},
	{
		name: 'Imagine',
		img: imgPath + 'Imagine.jpg',
		href: 'https://imagine.shopiko.bg'
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const EN = [
	{
		name: 'Spark',
		img: imgPath + 'Spark.jpg',
		href: 'https://spark.shopiko.bg'
	},
	{
		name: 'Gimp',
		img: imgPath + 'Gimp.jpg',
		href: 'https://gimp.shopiko.bg'
	},
	{
		name: 'Fashion Weeks',
		img: imgPath + 'FashionWeeks.jpg',
		href: 'https://fashionweeks.shopiko.bg'
	},
	{
		name: 'Luxury',
		img: imgPath + 'Luxury.jpg',
		href: 'https://luxury.shopiko.bg'
	},
	{
		name: 'Boutique',
		img: imgPath + 'Boutique.jpg',
		href: 'https://boutique.shopiko.bg'
	},
	{
		name: 'Imagine',
		img: imgPath + 'Imagine.jpg',
		href: 'https://imagine.shopiko.bg'
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];